'use client'

import React from 'react'
import { useRouter } from 'next/navigation'
import { ChevronLeft } from 'lucide-react'
import { cn } from '@/lib/utils'

import { Button, type ButtonProps } from '@/components/ui'

export const BackButton = ({
  className,
  children,
  onClick,
  ...restProps
}: ButtonProps) => {
  const router = useRouter()

  return (
    <Button
      variant="secondary"
      size="lg"
      onClick={onClick ? onClick : () => router.back()}
      className={cn('shrink-0 gap-1', className)}
      {...restProps}
    >
      <ChevronLeft className="size-5" />
      {children}
    </Button>
  )
}
